var map = {
	"./3_lines.png": 87170,
	"./3dModeller.png": 27659,
	"./AR11.jpg": 33895,
	"./ARImage1.jpg": 32824,
	"./ARImage2.jpg": 68960,
	"./About-MXR.png": 57961,
	"./Ar1Image.jpg": 62762,
	"./Ar2Image.jpg": 91076,
	"./ArVrShaping.jpg": 50315,
	"./ArVrShaping2.jpg": 20369,
	"./Case-study2.png": 1528,
	"./Case-study3.png": 90518,
	"./Chaar Sahibzade/CTA-bg.png": 54306,
	"./Chaar Sahibzade/GoogleStore.png": 34979,
	"./Chaar Sahibzade/appStore.png": 74860,
	"./Chaar Sahibzade/bottom-bg.png": 72663,
	"./Chaar Sahibzade/faqImg.png": 34959,
	"./Chaar Sahibzade/faqImg2.png": 61665,
	"./Chaar Sahibzade/step1.png": 42958,
	"./Chat-Bot.png": 44131,
	"./Chat-Bot2.jpg": 38019,
	"./ConstructionImage.jpg": 33086,
	"./Cos1.svg": 9324,
	"./Customer-centricity.svg": 6623,
	"./DinoWorld/CTA-bg.png": 49550,
	"./DinoWorld/GoogleStore.png": 51859,
	"./DinoWorld/appStore.png": 28575,
	"./DinoWorld/bottom-bg.png": 26793,
	"./DinoWorld/dino-front1.png": 58729,
	"./DinoWorld/dino-playstore1.png": 70999,
	"./DinoWorld/dino-step3.png": 74820,
	"./DinoWorld/faqImg.png": 81852,
	"./DinoWorld/faqImg2.png": 49284,
	"./DinoWorld/faqImg3.png": 59846,
	"./DinoWorld/faqImg4.png": 42017,
	"./DinoWorld/faqImg5.png": 63239,
	"./DinoWorld/step1.png": 23542,
	"./DinoWorld/step2.png": 9183,
	"./DinoWorld/step3.png": 11846,
	"./DinoWorld/step4.png": 48473,
	"./Exp1.svg": 99126,
	"./Generative-AIRevo.jpg": 15050,
	"./Immersive-Solutions.svg": 75819,
	"./Immersive-Technology2.jpg": 73995,
	"./Immersive-rooms3.png": 76157,
	"./Immersive-rooms33.jpg": 63142,
	"./Immersive-rooms4.jpg": 48633,
	"./Inn1.svg": 43472,
	"./Innerbanner/Blog.png": 7050,
	"./Innerbanner/BlueBanner.png": 14258,
	"./Innerbanner/Immersive-room.png": 50319,
	"./Innerbanner/about-banner.jpg": 69228,
	"./Innerbanner/aboutBlog.jpg": 94841,
	"./Innerbanner/ai.webp": 70146,
	"./Innerbanner/ar.webp": 63890,
	"./Innerbanner/arBanner.jpg": 58441,
	"./Innerbanner/arBanner5.jpg": 73120,
	"./Innerbanner/arbanner2.jpg": 91716,
	"./Innerbanner/arvrBlog.jpg": 40244,
	"./Innerbanner/augmentedBlog.jpg": 57789,
	"./Innerbanner/blog-page-main.jpg": 76135,
	"./Innerbanner/blue-background.png": 98137,
	"./Innerbanner/blue-background2.jpg": 68599,
	"./Innerbanner/blue-bg22.jpg": 82174,
	"./Innerbanner/codeigniter.jpg": 5932,
	"./Innerbanner/collegeTech2.png": 68645,
	"./Innerbanner/collegeTech3.png": 70044,
	"./Innerbanner/constructionBlog.jpg": 20153,
	"./Innerbanner/dinoBanner.png": 89605,
	"./Innerbanner/event.png": 61925,
	"./Innerbanner/event2.png": 90108,
	"./Innerbanner/event3.png": 74350,
	"./Innerbanner/immBlogbanner7.jpg": 85787,
	"./Innerbanner/immersiveBlogBanner.jpg": 6121,
	"./Innerbanner/immersiveUk.png": 97501,
	"./Innerbanner/immersiveUk2.jpg": 63960,
	"./Innerbanner/in.jpg": 8207,
	"./Innerbanner/mad.jpg": 51210,
	"./Innerbanner/mixedBlog.jpg": 38114,
	"./Innerbanner/mr.jpg": 67430,
	"./Innerbanner/partnerUkBlog.jpg": 5198,
	"./Innerbanner/project-project2.jpg": 57135,
	"./Innerbanner/projects.jpg": 70417,
	"./Innerbanner/reducestress.jpg": 14990,
	"./Innerbanner/services-research and innovation.jpg": 29292,
	"./Innerbanner/technology-android.jpg": 75096,
	"./Innerbanner/technology-angular.jpg": 18192,
	"./Innerbanner/technology-drupal.jpg": 37648,
	"./Innerbanner/technology-flutter.jpg": 1568,
	"./Innerbanner/technology-hybrid.jpg": 29261,
	"./Innerbanner/technology-ionic.jpg": 8163,
	"./Innerbanner/technology-ios.jpg": 16355,
	"./Innerbanner/technology-laravel.jpg": 79587,
	"./Innerbanner/technology-magento.jpg": 26003,
	"./Innerbanner/technology-mean.jpg": 64314,
	"./Innerbanner/technology-mern.jpg": 92094,
	"./Innerbanner/technology-php.jpg": 2993,
	"./Innerbanner/technology-phython.jpg": 71271,
	"./Innerbanner/technology-reactjs.png": 42899,
	"./Innerbanner/technology-reactnative.jpg": 258,
	"./Innerbanner/technology-shopify.jpg": 16979,
	"./Innerbanner/technology-swift.jpg": 26390,
	"./Innerbanner/technology-unity-app.jpg": 26420,
	"./Innerbanner/technology-unreal-engine-development.webp": 61797,
	"./Innerbanner/technology-vue.jpg": 79862,
	"./Innerbanner/technology-worldpress.jpg": 65049,
	"./Innerbanner/vr-360-banner.jpg": 80621,
	"./Innerbanner/vr-banner.svg": 38812,
	"./Innerbanner/vr-banner2.jpg": 66753,
	"./Innerbanner/webdesign.jpg": 71167,
	"./Innovative-Anxiety-Solutions5.jpg": 77059,
	"./InsightXrPhoto.png": 70319,
	"./InsightXrPhoto.svg": 84086,
	"./InsightXrPhoto1.svg": 6278,
	"./Mr.avif": 6058,
	"./Mr2.png": 52907,
	"./NHS.png": 64800,
	"./NHS2.jpg": 82859,
	"./Our-vission.png": 14345,
	"./Partnering.jpg": 75426,
	"./Platform1.png": 82796,
	"./Platform2.png": 91658,
	"./PlatformD.svg": 3102,
	"./ProjectM.svg": 37933,
	"./Reduced-Training-Time-and-Costs.jpg": 21390,
	"./Research-and-Innovation.jpg": 17349,
	"./Research.jpg": 78812,
	"./Research2.jpg": 84731,
	"./Right.png": 72529,
	"./Sol1.svg": 71013,
	"./Solution.png": 87383,
	"./Sup1.svg": 10634,
	"./TimeEffi.svg": 53162,
	"./UK-College.png": 26838,
	"./Understanding-Generative-AI.jpg": 46260,
	"./VR-case-study.png": 24030,
	"./VrApplications.jpg": 92071,
	"./acc.svg": 6089,
	"./access.svg": 22547,
	"./advance_features.png": 37627,
	"./advance_features2.jpg": 5567,
	"./advance_features3.png": 5935,
	"./ai.jpg": 39657,
	"./aiRevo.jpg": 62123,
	"./aidev3.svg": 79505,
	"./anatomyPic.jpg": 63236,
	"./anatomyPic2.jpeg": 47690,
	"./anim.gif": 7744,
	"./anim2.gif": 24741,
	"./anim3.gif": 83603,
	"./ar-detail.jpg": 8288,
	"./ar-main.avif": 80310,
	"./ar-technology.jpg": 68418,
	"./ar12.png": 77095,
	"./bg-image.jpg": 39826,
	"./blogImmersive.jpg": 86859,
	"./bot.svg": 53965,
	"./bot2.svg": 28017,
	"./bot3.png": 57814,
	"./bot4.png": 25303,
	"./case-study.png": 27996,
	"./case-study2.jpg": 79648,
	"./case-study4.png": 21402,
	"./collage-tech.jpg": 34106,
	"./colleges-revolution2.jpg": 27537,
	"./construction.jpeg": 22893,
	"./contact-banner.png": 69291,
	"./content.png": 17333,
	"./cta2-bg.png": 64123,
	"./dashboardDesktop.png": 18762,
	"./dataScience.png": 138,
	"./decreaseTime.svg": 37623,
	"./desktop.avif": 26639,
	"./desktop2.avif": 88590,
	"./desktop3.png": 40352,
	"./desktop4.png": 59114,
	"./desktopFinal.png": 95282,
	"./development.jpg": 27716,
	"./deviceManagement.png": 28236,
	"./doctor-examining.avif": 78084,
	"./education-revolution2.jpg": 47012,
	"./educationCollege.avif": 44031,
	"./enhanced.svg": 97984,
	"./enter1.svg": 91666,
	"./enter2.svg": 68648,
	"./enter3.svg": 77806,
	"./enter4.svg": 60950,
	"./enter5.svg": 25295,
	"./enter6.svg": 45840,
	"./event1.jpg": 31325,
	"./event2.jpg": 84058,
	"./eventASPiH.png": 38595,
	"./exam1.png": 71149,
	"./exam2.png": 4682,
	"./exam3.png": 33781,
	"./generativeAi.webp": 75686,
	"./human-exp.jpg": 75951,
	"./immersive-technology.jpg": 36461,
	"./immersive.png": 38426,
	"./immersive2.png": 34875,
	"./immersiveBlogImage.jpg": 58830,
	"./immersiveCollege.avif": 78461,
	"./immersiveRoom.jpg": 2480,
	"./immersiveRoomAnatomy.jpg": 24995,
	"./immersiveTechT.jpg": 97376,
	"./immersivehealthare.png": 4245,
	"./immersivetraining.png": 98632,
	"./insightXrApp.png": 73389,
	"./insightxr1.png": 48494,
	"./insightxr2.png": 16257,
	"./insightxr3.png": 54506,
	"./manage.svg": 42142,
	"./manwithVR.png": 62133,
	"./manwithVR2.png": 23659,
	"./mission.png": 30577,
	"./mixed-reality-training.jpg": 97316,
	"./monitor.svg": 86620,
	"./mrtrain.jpg": 54715,
	"./mxrBox.png": 71004,
	"./mxrBox2.jpg": 4312,
	"./mxrLogo.svg": 72945,
	"./mxr_logo.png": 31317,
	"./mxr_logo.svg": 55074,
	"./offer.png": 7753,
	"./operating.avif": 65342,
	"./partnership.jpg": 58792,
	"./partnership3.png": 38510,
	"./plc.svg": 32446,
	"./project-construction.png": 30810,
	"./project-manager.png": 79786,
	"./projects/virtual.jpg": 88820,
	"./proof.svg": 16674,
	"./reasearch-innovation.png": 20637,
	"./reduceStress.jpg": 88674,
	"./research-bg.jpg": 54298,
	"./research.svg": 19162,
	"./shaping-business.png": 57002,
	"./specific-Mixed.jpg": 91927,
	"./support-business.webp": 76955,
	"./support-business2.webp": 47546,
	"./support-business3.webp": 28387,
	"./system-engineer.png": 82954,
	"./track.svg": 16326,
	"./tranformEducation.webp": 53042,
	"./ukEduction.avif": 15020,
	"./unreal.png": 26300,
	"./userexp.png": 93193,
	"./viable.svg": 40578,
	"./videoXR.mp4": 65292,
	"./virtual.jpg": 69972,
	"./vrCase.png": 42559,
	"./vrImage1.jpg": 42873,
	"./vrImage2.jpg": 86142,
	"./webapp.svg": 20298,
	"./xr2.jpg": 47467,
	"./xr3.jpg": 724,
	"./xr4.jpg": 31886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;